import { render, staticRenderFns } from "./VSelectAfps.vue?vue&type=template&id=773aac04&"
import script from "./VSelectAfps.vue?vue&type=script&lang=js&"
export * from "./VSelectAfps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('773aac04')) {
      api.createRecord('773aac04', component.options)
    } else {
      api.reload('773aac04', component.options)
    }
    module.hot.accept("./VSelectAfps.vue?vue&type=template&id=773aac04&", function () {
      api.rerender('773aac04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/components/VSelectAfps.vue"
export default component.exports